import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SkillService } from 'src/app/Service/Skill/Skill.service';

@Component({
  selector: 'app-SkillAdd',
  templateUrl: './SkillAdd.component.html',
  styleUrls: ['./SkillAdd.component.scss']
})
export class SkillAddComponent implements OnInit {

  Token:String=""

  constructor(
    private Skill_Service:SkillService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewSkill=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      Rate:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,27).subscribe(
      data=>{
        
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewSkill:FormGroup;

  get_Form_Title(){
    return this.AddNewSkill.get('Title') as FormControl;
  }
  get_Form_Rate(){
    return this.AddNewSkill.get('Rate') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewSkill(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    Record.code=this.get_Form_Rate().value
    this.InProccessing=true
    this.Skill_Service.AddSkill(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
        }
        else{
          this.AddNewSkill.reset()
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();
        
      }
    )
  }



}
